import React, { useEffect, useState } from "react";
import axios from "axios";
import { Col, Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { getOverviewData } from "../../services/api/logsService.ts";
import { useNavigate } from "react-router-dom";

const USER_ROLE_ID = 5; // rôle "Utilisateur"

// Convertit une valeur décimale en minutes et secondes
const toMinSec = (val) => {
    const min = Math.floor(val);
    const sec = Math.round((val - min) * 60);
    return `${min}'${sec.toString().padStart(2, "0")}"`;
};

const OverView = ({ userlvl }) => {
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        if ([1, 2].includes(userlvl)) fetchData();
    }, [userlvl]);

    const fetchData = async () => {
        const [overviewRes, usersRes] = await Promise.all([
            getOverviewData(),
            axios.get("/api/user/list", { withCredentials: true }),
        ]);

        const overview = Array.isArray(overviewRes) ? overviewRes : overviewRes?.data || [];
        const users = Array.isArray(usersRes) ? usersRes : usersRes?.data || [];

        const simpleUserIds = new Set(
            users
                .filter(u => Number(u.user_ROLE_ID) === USER_ROLE_ID)
                .map(u => Number(u.user_ID))
        );

        setData(overview.filter(u => simpleUserIds.has(Number(u.user_ID))));
    };

    if (![1, 2].includes(userlvl)) return null;

    const categories = data.map(
        u => `${u.user_NAME} ${u.user_SURNAME}`
    );

    const chartOptions = {
        chart: {
            /*height: 350,*/
            type: "line",
            stacked: false,
            toolbar: { show: false, },
            events: {
                dataPointSelection: (event, chartContext, config) => {
                    if (event) {
                        event.stopPropagation();
                    }

                    const userIndex = config.dataPointIndex;
                    const user = data[userIndex];

                    if (user && user.user_ID) {
                        setTimeout(() => {
                            navigate(`/user-dashboard/${user.user_ID}`);
                        }, 0);
                    }
                },
            },
        },
        stroke: {
            width: [1, 1, 1],
            dashArray: [0, 0, 5],
            curve: "smooth",
        },
        /*plotOptions: {
            bar: {
                columnWidth: "100%",
            },
        },*/

        colors: ['#31c0fc', '#0d4498', '#74788d'],
        fill: {
            opacity: [0.6, 0.85, 0.85],
        },
        xaxis: { categories },
        yaxis: [
            {
                title: { text: "Score (%)" },
                /*max: 100,*/
                labels: {
                    formatter: function (val) {
                        return Math.round(val);
                    }
                }
            },
            {
                /*title: { text: "Moyenne générale (%)" },*/
                show: false,
                opposite: true,
                labels: {
                    formatter: function (val) {
                        return Number(val).toFixed(0);
                    }
                }
            },
            {
                title: { text: "Nombre d'essais" },
                show: true,
                opposite: true,
                labels: {
                    formatter: function (val) {
                        return Math.round(val);
                    }
                }
            }
        ],
    };

    const series = [
        {
            name: "Dernier Score (%)",
            type: "column",
            data: data.map(u => Math.round(Number(u.lastScore || 0))), // A CHANGER
        },
        {
            name: "Moyenne générale (%)",
            type: "line",
            //data: data.map(u => Number(Number(u.avgTime || 0).toFixed(2))),
            data: data.map(u => Math.round(Number(u.avgScore || 0))),
        },
        {
            name: "Nombre d'essais",
            type: "line",
            data: data.map(u => Math.round(Number(u.logsCount || 0))),
        },
    ];

    return (
        <Col xl={12}>
            <Card>
                <CardBody>
                    <h5 className="card-title mb-4">
                        Performances des utilisateurs
                    </h5>

                    <ReactApexChart
                        options={chartOptions}
                        series={series}
                        height={350}
                    />
                </CardBody>
            </Card>
        </Col>
    );
};

export default OverView;
